import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export interface GetUserStatParam {
	client?: string
}

export type GetUserStatResponse = Array<{
	_id: {
		active: boolean
	}
	count: number
}>
const getUserStats = async (
	params: GetUserStatParam
): Promise<GetUserStatResponse> => {
	try {
		const { data } = await axios.get('v1/admin/management/active-inactive/user', {
			params,
		})
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}
export default getUserStats
